import formatPrice from 'common/helpers/modifiers/formatPrice'
import { constants, getTotalAndBalance } from 'common/helpers'
import { getFeatureToggle } from 'helpers'
import { getState } from 'redux/core'

import messages from './messages'


const getBillData = (values = {}) => {
  const {
    models: { me: { balance } },
    view: { redeemTossInPage: { useCredits } },
  } = getState()

  const {
    shipping: shippingPrice, tax = 0, discount = 0, credits = 0,
    ecommerceCredits = 0, subtotal = 0, price = 0,
  } = values

  const totalPrices                 = getTotalAndBalance({ useCredits, price, balance, credits })
  const isTossInCartSubtotalEnabled = getFeatureToggle(constants.features.tossInCartSubtotal)

  const items = []

  if (isTossInCartSubtotalEnabled) {
    items.push({
      id: 'billSubtotalRow',
      label: messages.subtotal,
      value: formatPrice(subtotal, true),
    })
  }

  // Shipping ----------------------------------------------------------- /

  items.push({
    id: 'billShippingRow',
    label: messages.shipping,
    value: shippingPrice ? formatPrice(shippingPrice, true) : messages.free,
    amount: formatPrice(0, true, false),
    brand: true,
  })

  // Tax ---------------------------------------------------------------- /

  items.push({
    id: 'billTaxRow',
    label: messages.tax,
    value: formatPrice(tax, true),
    amount: formatPrice(tax, true, false),
  })

  // Discount ----------------------------------------------------------- /

  if (discount) {
    const discountLabel = messages.discount
    const discountValue = typeof discount === 'string'
      ? discount
      : formatPrice(discount, true)

    const discountApplePayValue = formatPrice(discount, true, false)

    items.push({
      id: 'discountRow',
      label: discountLabel,
      value: discountValue,
      amount: discountApplePayValue,
      brand: true,
    })
  }

  // Ecommerce Credits ---------------------------------------------------- /

  if (ecommerceCredits) {
    items.push({
      id: 'ecommerceCreditsRow',
      label: messages.ecommerceCredits,
      value: formatPrice(ecommerceCredits, true),
      amount: formatPrice(ecommerceCredits, true, false),
    })
  }

  // Total ---------------------------------------------------------------- /

  return { items, credits, balance, ...totalPrices }
}


export {
  getBillData,
}
